import axios from "axios";
const api = axios.create({
  /* baseURL: process.env.REACT_APP_API_URL, */
  // baseURL: 'https://localhost:44384/api/', //local development
  baseURL: "https://pro-slay-api.ginilytics.com/api/", //staging
  // baseURL: 'https://api.proslay.com/api/', //production
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem("accessToken");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);
export default api;
